import axios from "axios";

const origin = window.location.origin;
const baseURL = process.env.REACT_APP_BASE_URL_API.includes("http")
  ? process.env.REACT_APP_BASE_URL_API
  : `${origin}/${process.env.REACT_APP_BASE_URL_API}`;

const mainApi = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

mainApi.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
mainApi.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default mainApi;
